import React, { useEffect, useState } from "react";
import { cqAPI } from "../../lib/Auth";
import {
  Box,
  Flex,
  Text,
  VStack,
  HStack,
  Checkbox,
  Select as ChakraSelect,
  useTheme,
  useColorMode,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Spinner,
  ModalCloseButton,
  ModalBody,
  IconButton,
  ModalFooter,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  Menu,
  MenuItem,
  MenuButton,
  useToast,
  MenuList,
} from "@chakra-ui/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

import EditableText from "../EditableText/EditableText";

import { AddIcon } from "@chakra-ui/icons";

import Select from "react-select";
import dialogManager from "../DialogManager/DialogManager";

const [emailExp, nameExp] = [
  /^[^ @\>\)\(\<]{1,}@[^.@ ]{1,}.[^@ \>\<\)\(]+/,
  /[a-zA-Z]+\ [a-zA-Z]+/,
];

const HEADER_NOTICE = "Notice";
const HEADER_ERROR = "Error";

function UserManagement() {
  const theme = useTheme();
  const { colorMode } = useColorMode();
  const [userData, setUserData] = useState({
    employees: [],
  });

  const {
    isOpen: isNewUserOpen,
    onOpen: onNewUserOpen,
    onClose,
  } = useDisclosure();

  const [bidOrGroupNameByIds, setBidOrGroupNameByIds] = useState([]);
  const [selectedGroupOrGroupId, setSelectedGroupOrGroupId] = useState();
  const [isSavingNewUser, setIsSavingNewUser] = useState(false);
  const [groupsByPid, setGroupsByPid] = useState({});
  const [rolesByPid, setRolesByPid] = useState({});
  const [roleNamesById, setRoleNamesById] = useState({});
  const [groupRolesByPidBid, setGroupRolesByPidBid] = useState({});
  const [rolesForExmployees, setRolesForExmployees] = useState({});
  const [roles, setRoles] = useState([]);
  const [newUser, setNewUser] = useState({name: "", email: "", roles: []});
  const toast = useToast();

  // Modified onNewUserClose function
  const onNewUserClose = () => {
    setNewUser({name: "", email: "", roles: []}); // Reset newUser state
    onClose(); // Use the onClose function from useDisclosure
  };

  const fetchUserData = async () => {
    const response = await cqAPI.get(`/settings/users`);
    const bidsAndGroups = Object.keys(response.data.businessOrGroupNameById);
    setSelectedGroupOrGroupId(bidsAndGroups[0]);
    setGroupsByPid(response.data.groupsByPid);
    setRolesByPid(response.data.rolesByPid);
    setRoleNamesById(response.data.roleNamesById);
    setBidOrGroupNameByIds(bidsAndGroups);
    setGroupRolesByPidBid(response.data.groupRolesByPidBid);
    setRoles(
      response.data.roles.map((role) => ({
        value: role.role,
        label: role.name,
      }))
    );
    setUserData(response.data);
  };

  const getValuesToSelectValues = (values) =>
    values.map((v) => ({
      value: v,
      label: userData.roles.find((r) => r.role == v)?.name,
    }));

  const getRolesForEmployee = (pid) => {
    const groups = groupsByPid[pid];

    let values = [];

    if (groups && groups[selectedGroupOrGroupId]) {
      values = getValuesToSelectValues(
        groupsByPid[pid][selectedGroupOrGroupId] || []
      );
    } else {
      values = getValuesToSelectValues(
        rolesByPid[pid][selectedGroupOrGroupId] || []
      );
      if (
        groupRolesByPidBid[pid] &&
        groupRolesByPidBid[pid][selectedGroupOrGroupId]
      ) {
        userData.roles.forEach((role) => {
          if (
            groupRolesByPidBid[pid][selectedGroupOrGroupId].indexOf(
              role.role
            ) != -1
          ) {
            const v = values.find((x) => x.value == role.role);
            if (v) {
              v.isDisabled = true;
            }
          }
        });
      }
    }
    return values;
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleRoleChange = async (pid, selectedRoles) => {
    const values = selectedRoles.map((v) => v.value);

    rolesByPid[pid][selectedGroupOrGroupId] =
      rolesByPid[pid][selectedGroupOrGroupId] || [];

    let oldRoles = (
      (rolesByPid[pid] || {})[selectedGroupOrGroupId] || []
    ).slice();
    let oldGroups = (
      (groupsByPid[pid] || {})[selectedGroupOrGroupId] || []
    ).slice();

    if (selectedGroupOrGroupId.indexOf("-group") == -1) {
      rolesByPid[pid][selectedGroupOrGroupId] = values;
    } else {
      groupsByPid[pid][selectedGroupOrGroupId] = values;
    }

    let permissions = [];

    Object.keys(rolesByPid[pid] || {}).forEach(function (bidOrGroup_) {
      let except_roles = [];
      if (
        selectedGroupOrGroupId.indexOf("-group") == -1 &&
        groupRolesByPidBid[pid] &&
        groupRolesByPidBid[pid][bidOrGroup_]
      ) {
        except_roles = groupRolesByPidBid[pid][bidOrGroup] || [];
      }
      (rolesByPid[pid][bidOrGroup_] || []).forEach(function (roleName) {
        if (except_roles.indexOf(roleName) == -1) {
          permissions.push(roleName + ":" + bidOrGroup_);
        }
      });
    });

    Object.keys(groupsByPid[pid] || {}).forEach(function (bidOrGroup_) {
      var except_roles = [];
      if (
        selectedGroupOrGroupId.indexOf("-group") == -1 &&
        groupRolesByPidBid[pid] &&
        groupRolesByPidBid[pid][bidOrGroup_]
      ) {
        except_roles = groupRolesByPidBid[pid][bidOrGroup_] || [];
      }
      (selectedGroupOrGroupId[pid][bidOrGroup_] || []).forEach(function (
        roleName
      ) {
        if (except_roles.indexOf(roleName) == -1) {
          permissions.push(roleName + ":" + bidOrGroup_);
        }
      });
    });

    const result = await cqAPI.post("/settings/role", {
      pid: pid,
      role: permissions,
    });

    if (!result) return;

    if (result.type == "error") {
      if (result.msg) {
        dialogManager.open({
          onDeny: () => {},
          acceptText: "OK",
          body: result.msg,
          header: HEADER_ERROR,
        });
      }
    } else {
      setRolesForExmployees({ ...rolesForExmployees, [pid]: selectedRoles });
    }
  };

  const hoverBgColor =
    colorMode === "light" ? theme.colors.gray[200] : theme.colors.gray[700];
  const selectBgColor =
    colorMode === "light" ? theme.colors.gray[50] : theme.colors.darkBackground;
  const dividerColor =
    colorMode === "light" ? "gray.200" : "gray.700";
  const textColor =
    colorMode === "light" ? theme.colors.lightText : theme.colors.darkText;

  const handleSaveNewUser = async () => {
    if (!nameExp.test(newUser.name)) {
      toast({
        title: "Not a valid value",
        description: "Please enter a valid name: First Last",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (!emailExp.test(newUser.email)) {
      toast({
        title: "Not a valid value",
        description: "Please enter a valid email address.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (!newUser.roles.length) {
      toast({
        title: "Not a valid value",
        description: "Please select at least one role.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const response = await cqAPI.post(`/settings/users/invite`, {
      email: newUser.email,
      name: newUser.name.trim(),
      role: newUser.roles.map((x) => x.value),
    });
    if (response.msg) {
      dialogManager.open({
        onDeny: () => {},
        acceptText: "OK",
        body: response.msg,
        header: HEADER_NOTICE,
      });
    }
    if (response.type == "ok") {
      onNewUserClose();
      await fetchUserData();
    }
  };

  const NewUserModal = (
    <Modal isOpen={isNewUserOpen} onClose={onNewUserClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="left">Invite a new team member</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel textAlign="left">Full Name</FormLabel>
              <Input
                placeholder="Full Name"
                value={newUser.name}
                onChange={(e) =>
                  setNewUser({ ...newUser, name: e.target.value })
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel textAlign="left">Email</FormLabel>
              <Input
                placeholder="Email"
                value={newUser.email}
                onChange={(e) =>
                  setNewUser({ ...newUser, email: e.target.value })
                }
              />
            </FormControl>

            <FormControl>
              <FormLabel textAlign="left">Roles</FormLabel>
              <Select
                options={roles}
                isMulti
                onChange={(e) => setNewUser({ ...newUser, roles: e })}
                value={newUser.roles}
                styles={{
                  control: (base) => ({ ...base, backgroundColor: hoverBgColor }),
                  menu: (base) => ({ ...base, backgroundColor: selectBgColor }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused
                      ? selectBgColor   // Color when hovered
                      : hoverBgColor, // Default background color
                  }),
                }}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSaveNewUser}>
            Save
            {isSavingNewUser && <Spinner size="sm" ml="2" />}
          </Button>
          <Button variant="ghost" onClick={onNewUserClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );

  const updateUserName = async (uid, name) => {
    const response = await cqAPI.post(`/settings/users`, {
      name: name,
      pid: uid,
    });
    if (response.msg) {
      dialogManager.open({
        onDeny: () => {},
        acceptText: "OK",
        body: response.msg,
        header: HEADER_ERROR,
      });
    }
    if (response.type == "ok") {
      return true;
    }
    return false;
  };

  const resendInvitation = async (uid, email) => {
    const response = await cqAPI.post(`/settings/users/resend`, {
      pid: uid,
      ...(email ? { email } : {}),
    });
    if (response.msg) {
      dialogManager.open({
        onDeny: () => {},
        acceptText: "OK",
        body: response.msg,
        header: HEADER_NOTICE,
      });
    }
    if (response.type == "ok") {
      toast({
        title: "Success",
        description: "The invitation was resent.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      return true;
    }
    return false;
  };

  const deleteAllAccess = async (uid) => {
    const response = await cqAPI.del(`/settings/users`, {
      pid: uid,
    });
    if (response.msg) {
      dialogManager.open({
        onDeny: () => {},
        acceptText: "OK",
        body: response.msg,
        header: HEADER_ERROR,
      });
    }
    if (response.type == "ok") {
      setUserData({
        ...userData,
        employees: userData.employees.filter(
          (employee) => employee._id !== uid
        ),
      });
    }
  };

  return (
    <Box p={4} overflowY="auto" height="100%" width="100%">
      {NewUserModal}
      <Flex justifyContent="flex-end" mb={4}>
        <Button leftIcon={<AddIcon />} onClick={onNewUserOpen}>
          Add User
        </Button>
      </Flex>
      <VStack spacing={4} align="stretch" mb={40}>
        <Flex borderBottom="1px" borderColor={dividerColor} p={2}>
          <HStack spacing={8} flex="1">
            <Text
              fontSize="sm"
              flexBasis="20%"
              fontWeight="bold"
              cursor="pointer"
            >
              Info
            </Text>
            {false && (
              <Text
                fontSize="sm"
                flexBasis="10%"
                fontWeight="bold"
                cursor="pointer"
              >
                Remote Access
              </Text>
            )}
            <Text
              fontSize="sm"
              flexBasis="35%"
              fontWeight="bold"
              cursor="pointer"
            >
              Locations
            </Text>
            <Text
              fontSize="sm"
              flexBasis="30%"
              fontWeight="bold"
              cursor="pointer"
            >
              Roles
            </Text>
            <Text
              fontSize="sm"
              flexBasis="5%"
              fontWeight="bold"
              cursor="pointer"
            >
              Action
            </Text>
          </HStack>
        </Flex>
        {userData.employees.map((employee) => (
          <Flex
            key={employee._id}
            borderBottom="1px" borderColor={dividerColor}
            p={2}
            _hover={{ bg: hoverBgColor, cursor: "pointer" }}
          >
            <HStack spacing={8} flex="1">
              <Flex direction="column" justifyContent="left" flexBasis="20%">
                <Flex>
                  <EditableText
                    initialValue={employee.name}
                    onSave={(newValue) =>
                      updateUserName(employee._id, newValue)
                    }
                    placeholder="Name"
                    pattern={nameExp}
                    invalid="Enter a valid full name: First Last"
                  />
                </Flex>
                <Flex paddingTop="10px">
                  <EditableText
                    initialValue={employee.email}
                    editable={employee.verified ? false : true}
                    onSave={(newValue) =>
                      resendInvitation(employee._id, newValue)
                    }
                    placeholder="Email"
                    pattern={emailExp}
                    invalid="Please enter a valid email address."
                  />
                </Flex>
              </Flex>
              {false && (
                <Checkbox
                  isChecked={employee.remote_access}
                  justifyContent="center"
                  flexBasis="10%"
                ></Checkbox>
              )}
              <ChakraSelect
                flexBasis="35%"
                value={selectedGroupOrGroupId}
                onChange={(e) => setSelectedGroupOrGroupId(e.target.value)}
              >
                {bidOrGroupNameByIds.map((bidOrGroup, index) => {
                  let roles = "";
                  const isGroup = bidOrGroup.indexOf("-group") !== -1;
                  const ids = isGroup
                    ? (groupsByPid[employee._id] || {})[bidOrGroup]
                    : (rolesByPid[employee._id] || {})[bidOrGroup] || [];
                  ids.forEach((id, idx) => {
                    roles += `${idx > 0 ? ", " : ""}${roleNamesById[id] || id}`;
                    if (roles.length > 40) {
                      roles = `${roles.substr(0, 40)}...`;
                    }
                  });
                  roles = roles || "no roles";
                  return (
                    <option key={index} value={bidOrGroup}>
                      {userData.businessOrGroupNameById[bidOrGroup]} - {roles}
                    </option>
                  );
                })}
              </ChakraSelect>
              <Box flexBasis="30%">
                <Select
                  onChange={(e) => handleRoleChange(employee._id, e)}
                  options={roles}
                  isMulti
                  value={
                    rolesForExmployees[employee._id] ||
                    getRolesForEmployee(employee._id)
                  }
                  styles={{
                    control: (base) => ({ ...base, backgroundColor: selectBgColor, color: textColor, borderColor:dividerColor }),
                    menu: (base) => ({ ...base, backgroundColor: selectBgColor }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                          ? hoverBgColor   // Color when hovered
                          : selectBgColor, // Default background color
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: theme.colors.brand[50], // Set the background color of the role
                      borderRadius: '100px',         // Adjust the border radius
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: theme.colors.brand[300],         // Set the text color of the role
                      marginLeft: "10px",
                    }),
                    multiValueRemove: (base, state) => ({
                      ...base,
                      color: theme.colors.brand[300], // Same as text color
                      borderRadius: '0 100px 100px 0',
                      ':hover': {
                        backgroundColor: theme.colors.brand[100],
                        color: theme.colors.brand[400],
                      },
                    }),
                  }}
                />
              </Box>
              <Menu flexBasis="5%">
                <MenuButton
                  as={IconButton}
                  icon={<FontAwesomeIcon icon={faEllipsisV} />}
                  backgroundColor={hoverBgColor}
                  color={theme.colors.iconColor}
                />
                <MenuList>
                  {employee.verified && (
                    <MenuItem onClick={() => deleteAllAccess(employee._id)}>
                      Remove All Access
                    </MenuItem>
                  )}
                  {!employee.verified && (
                    <>
                      <MenuItem onClick={() => deleteAllAccess(employee._id)}>
                        Rescind Invitation
                      </MenuItem>
                      <MenuItem onClick={() => resendInvitation(employee._id)}>
                        Resend Invitation
                      </MenuItem>
                    </>
                  )}
                </MenuList>
              </Menu>
            </HStack>
          </Flex>
        ))}
      </VStack>
    </Box>
  );
}

export default UserManagement;
